'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import 'styles/PageRow.scss';

const propTypes = {
    id: PropTypes.string,
};

class PageRow extends React.Component {

    render() {

    	var className = classNames(
    		'page-row',
    		{'compact-sections': this.props.compactSections},
    		{'not-full-page': this.props.notFullPage},
    		{'reduce-margin': this.props.reduceMargin},
            {'no-flex': this.props.noFlex}
    	);

        return (
            <div id={this.props.id} className={className} ref="row">
                {this.props.heading ? <div><h4>{this.props.heading}</h4></div> : null}
                {this.props.children}
            </div>
        );
    }
}

PageRow.propTypes = propTypes;

export default PageRow; 
